module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAABSklEQVRIS6WWIVIEQQxF30okFgkWCZIzYJEgOQOSQ2CRILkC4EBischdiaV+VUI12XR3hp2qVZP+r/vnd2ZX1J8D4NLK74GvytJVpQiQ+DWwZ/XfwF0FUgFEcd9TCTIDRPF3Uz+pnmQEyMQfTPgCKEF6gJG4W9RCPq0nWy3NABVxFzoHzoAn4CULTAQsEY96x8Ah8Aqs/WUL2EVcercW4z/pckBFXDuUHXpkx0c4Qtp4AarifotdV7d5ChHgBti3Vcq5R7HdoG7xUdhxLzntSdYR8AY8Jmn4L2CTWZRB5H+0KIvmVh96Te5BvMnyPube74QM+E3SKKY9u3oDeBhTXxQTtQQiG/V7bsd4ZVSMIO657FJPSrNIRZWTtA1VT3QvyoAZZOdxPeqJ3p1awfSrNvuiZSdx+FRchRVABimJLwE45MpmvRJT+tvyA3Q1akIYDg7IAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/navbar.png
// module id = Ld2O
// module chunks = 1